import { render } from "./mainHome.vue?vue&type=template&id=0d2d47b3&scoped=true"
import script from "./mainHome.vue?vue&type=script&lang=js"
export * from "./mainHome.vue?vue&type=script&lang=js"

import "./mainHome.vue?vue&type=style&index=0&id=0d2d47b3&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2d47b3"]])

export default __exports__